<template>
  <header>
    <!-- HEADER ON DESKTOP -->
    <nav class="navbar-desktop">
      <div class="left">
      </div>
      <div class="left">
        <router-link :to="{ name: 'Home' }" class="logo">
          <img v-bind:src="data.logo_img_url">
        </router-link>
      </div>
      <div class="right">
        <div class="action">

          <div class="notify">
            <div class="cart-icon">
              <span class="fa fa-shopping-cart"></span>
              <span class="show-side-header">Cart</span>
              <span class="cart-total">{{ total_items }}</span>
            </div>
            <shopping :total_items="total_items" :type="'desktop'"></shopping>

          </div>
          <span class="cl-img search-icon" data-toggle="modal" data-target="#modalSearch"></span>
        </div>
      </div>
    </nav>

    <nav class="navbar navbar-mobile fixed-top">
      <div class="heading">
        <a :href="data.rest_ws_url" class="logo">
          <img v-bind:src="data.logo_img_url">
        </a>
        <div class="right">
          <button class="navbar-toggler navbar-dark collapsed" @click="showShopping">
            <i class="fa fa-shopping-cart"></i>
          </button>
          <button v-if="isMenuRoute" class="navbar-toggler navbar-dark collapsed" @click="showMenu">
            Menu
          </button>
          <button v-else class="navbar-toggler navbar-dark collapsed" @click="showHome">
            <router-link :to="{ name: 'Home' }"><i class="fa fa-home"></i></router-link>
          </button>
        </div>
      </div>
      <div class="hide" id="shoppingCart" :class="showShoppingClass">
        <shopping :total_items="total_items" :type="'mobile'"></shopping>

      </div>
      <div class="hide" id="navbarCollapse" :class="showHomeClass" ref="mobileMenu">
        <scrollactive>
          <ul class="navbar-nav mr-auto">
            <li v-for="(c, index) in data.categories" :key="index">
              <a
                :href="'#' + slugify(c.title)"
                class="scrollactive-item"
                @click.prevent="onMobileCategoryClick(c)"
              >
                {{ c.title }}
              </a>
            </li>
          </ul>
        </scrollactive>
      </div>
    </nav>
  </header>
</template>

<script>
import Vue from 'vue'
import {itemsStorage} from '../main.js';
import Shopping from './Shopping.vue';

export default {
  components: {
    'shopping': Shopping,
  },
  props: ['data'],
  data() {
    return {
      'total_items': 0,
      'showShoppingClass': "",
      'showHomeClass': ""
    }
  },
  computed: {
    isMenuRoute() {
      const routeName = this.$route && this.$route.name
      return routeName === 'Home' || routeName === 'Category'
    }
  },
  methods: {
    showShopping() {
      if (this.showShoppingClass == "") this.showShoppingClass = "show";
      else this.showShoppingClass = "";
      this.showHomeClass = "";
    },
    hideShopping() {
      this.showShoppingClass = "";
      this.closeMobileMenu();
    },
    showMenu() {
      if (this.showHomeClass == "") this.showHomeClass = "show";
      else this.showHomeClass = "";
      this.showShoppingClass = "";
    },
    showHome() {
      this.showShoppingClass = "";
      this.closeMobileMenu();
    },
    closeMobileMenu() {
      this.showHomeClass = "";
      this.$nextTick(() => {
        const menu = this.$refs.mobileMenu
        if (menu) {
          menu.classList.remove('show')
        }
      })
    },
    slugify(value) {
      if (value === null || value === undefined) {
        return ""
      }
      return value
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '')
    },
    onMobileCategoryClick(category) {
      if (!category || !category.title) {
        this.showHome()
        return
      }

      const slug = this.slugify(category.title)
      const targetPath = slug ? `/${slug}` : '/'
      const scrollToCategory = () => {
        this.$nextTick(() => {
          this.scrollToCategory(slug)
        })
      }

      this.showHome()

      if (this.$route.path === targetPath) {
        scrollToCategory()
        return
      }

      this.$router.push(targetPath)
        .then(scrollToCategory)
        .catch((error) => {
          if (!error || error.name !== 'NavigationDuplicated') {
            throw error
          }
          scrollToCategory()
        })
    },
    scrollToCategory(slug) {
      if (!slug) {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        return
      }

      const target = document.getElementById(slug)
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  },
  mounted() {
    if (localStorage.total_items) {
      this.total_items = localStorage.total_items
    } else {
      this.total_items = 0
    }

    itemsStorage.$on('updateItem', (total) => {
      this.total_items = localStorage.total_items
    });
  },
  watch: {
    '$route'(to, from) {
      this.hideShopping()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue